<template>
  <div style="position: relative" :style="rootCssVar">
    <div class="vws-rule-custom" style="user-select: none;">
      <div class="vws-rule-row">
        <div class="vws-table-rule">
          <div class="vws-table-rule-heading">
            <div
              class="vws-time-list vws-rule-time-time vws-time-rule border-bottom"
            >
              {{ strTime }}
            </div>

            <div
              v-for="(day, daynum) in days"
              :key="daynum"
              class="text-center day-week-head"
              @click="toggleFullDay(daynum, checkFullDay(daynum))"
            >
              {{ day }}
            </div>
          </div>
          <div id="schelude" ref="draggableArea" class="vws-table-rule-body">
            <div
              v-for="(t, idx) in timeArray"
              ref="ruleTime"
              :key="idx"
              class="vws-rule-time"
            >
              <div
                ref="ruleTimeTime"
                class="vws-time-list vws-rule-time-time vws-time-rule"
                :data-val="t"
                @click="toggleWeek(idx, checkFullWeek(idx))"
              >
                {{ t }}
              </div>
              <div
                v-for="(day, daynum) in days"
                :key="daynum"
                ref="ruleTimeItem"
                class="vws-time-list vws-rule-time-item"
                :class="[timetable[daynum][idx]]"
                @click="toggleDay(daynum, idx)"
              >
                <span />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { STATUS_AVAILABLE, STATUS_VACATION, STATUS_LEAVING, STATUS_MOVED, STATUS_ILL } from './statuses';
import i18n from '@/i18n';
import { STATUS_AVAILABLE, STATUS_BUSY } from './statuses';

export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: []
      })
    },
    days: {
      type: Array,
      default: () => [
        i18n.t('scheduler.weekdays.monday'),
        i18n.t('scheduler.weekdays.tuesday'),
        i18n.t('scheduler.weekdays.wednesday'),
        i18n.t('scheduler.weekdays.thursday'),
        i18n.t('scheduler.weekdays.friday'),
        i18n.t('scheduler.weekdays.saturday'),
        i18n.t('scheduler.weekdays.sunday'),
      ],
      validator: val => val.length === 7
    },
    times: {
      type: Array,
      default: () => [
        '06:00',
        '07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00',
        '23:00'
      ],
      validator: val => val.length >= 0
    },
    interval: {
      type: Number,
      default: 60
    },
    bg: {
      type: String,
      default: '#fff'
    },
    bgHover: {
      type: String,
      default: '#5A30F020'
    },
    bgActive: {
      type: String,
      default: '#4CAF50'
    },
    textColor: {
      type: String,
      default: '#000'
    },
    strWeek: {
      type: String,
      default: ''
    },
    strTime: {
      type: String,
      default: ''
    },
    strDay: {
      type: String,
      default: ''
    },
    status: {
      type: String,
      default: STATUS_AVAILABLE
    },
    disableDaySelect: {
      type: Boolean,
      default: false
    },
    disableWeekSelect: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      steps: this.interval,
      timeArrayLength: 24,
      timeArray: this.times,
      timetable: {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: []
      },
      dragValue: false,
      dragging: false,
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      maxX: 0,
      maxY: 0,
      minX: 1000000,
      minY: 1000000,
      dragWeek: false,
      dragDay: false
    };
  },
  computed: {
    rootCssVar() {
      return {
        '--vws-bg': this.bg,
        '--vws-bgActive': this.bgActive,
        '--vws-bgHover': this.bgHover,
        '--vws-text': this.textColor,
        '--vws-padding': this.dense ? 0 : '10px'
      };
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.timetable = val;
      }
    }
  },
  mounted() {
    // this.setupCustom();
    if (this.value) {
      this.timetable = this.value;
    }
    // console.log(this.times, this.timetable);

    window.addEventListener('mouseup', this.stopDrag);
  },
  methods: {
    checkFullDay(dayIndex) {
      return this.timetable[dayIndex].every(time => !!time);
    },

    toggleFullDay(dayIndex) {
      const newTimeTable = this.timetable;

      console.log('check', this.checkFullDay(dayIndex));

      const newStatus = this.checkFullDay(dayIndex) ? '' : this.status;
      newTimeTable[dayIndex].fill(newStatus);
      this.timetable = Object.assign({}, newTimeTable);
      this.$emit('input', this.timetable);
    },

    checkFullWeek(timeIndex) {
      const weekTimeValues = Object.values(this.timetable).map(
        dayRow => dayRow[timeIndex]
      );
      return weekTimeValues.every(dayTime => !!dayTime);
    },

    toggleWeek(timeIndex) {
      const newTimeTable = this.timetable;
      const newStatus = this.checkFullWeek(timeIndex) ? '' : this.status;
      Object.values(newTimeTable).forEach(dayRow => {
        dayRow[timeIndex] = newStatus;
      });
      this.timetable = Object.assign({}, newTimeTable);
      this.$emit('input', this.timetable);
    },

    toggleDay(dayIndex, timeIndex) {
      if (this.status === STATUS_AVAILABLE || this.status === STATUS_BUSY) {
        const newTimeRow = this.timetable[dayIndex];
        newTimeRow[timeIndex] = newTimeRow[timeIndex] ? '' : this.status;
        this.timetable = Object.assign({}, this.timetable, {
          [dayIndex]: newTimeRow
        });
        this.$emit('input', this.timetable);
        return;
      }
      this.toggleFullDay(dayIndex);
    },

  }
};
</script>

<style scoped>
@import url('../assets/style.css');
.vws-time-rule {
  border-left: 1px solid #ccc;
}

.day-week-head {
  border-top: 1px solid #ccc;
}

.week-rule {
  border-top: 1px solid #ccc;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
}

.border-bottom {
  border-top: none;
  border-left: 1px solid white;
  border-bottom: 1px solid #ccc !important;
}

.vws-rule-time-time {
  text-align: center;
  padding: 0 1px;
  min-width: 30px;
}

.vws-rule-time-time:hover,
.day-week-head:hover {
  cursor: pointer;
}

.vws-table-rule-heading div,
.vws-rule-time .vws-time-list {
  /* padding: 1px !important; */
}

.selectall {
  background-color: rgb(247, 242, 242);
}

/* available */
.a {
  background-color: #4caf50;
}
/* vacation */
.v {
  background-color: #03a9f4;
}
/* leaving */
.l {
  background-color: #9c27b0;
}
/* move */
.m {
  background-color: #009688;
}
/* is ill */
.i {
  background-color: #ffd600;
}
/* negative */
.n {
  background-color: #d50000;
}
/* lost */
.p {
  background-color: #e91e63;
}
/* fire */
.f {
  background-color: #757575;
}
.b {
  background-color: #424242;
}
</style>
